module.exports = __webpack_public_path__ + "static/img/function2.da6feb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/function2.png
// module id = wX4E
// module chunks = 4